import { ApiClient } from '../../../api/client';
import { 
  BiasesResponse,
  GenerateResponse,
  TemplateForm,
  TemplateGenerationParams,
  AnalysisTaskResponse,
  TaskResponse,
  ModelsResponse
} from '../types/index';

export class TemplateApi {
  private static async request<T>(
    method: 'get' | 'post',
    url: string,
    data?: any
  ): Promise<T> {
    const api = await ApiClient.getInstance();
    const response = method === 'get' 
      ? await api.get<T>(url)
      : await api.post<T>(url, data);
    return response.data;
  }

  public static async getBiases(): Promise<BiasesResponse> {
    try {
      console.log('TemplateApi: Fetching biases...');
      const response = await this.request<BiasesResponse>('get', '/biases');
      console.log('TemplateApi: Biases response:', response);
      return response;
    } catch (error) {
      console.error('TemplateApi: Error fetching biases:', error);
      throw error;
    }
  }
  
  public static async analyzeTemplate(
    template: TemplateForm
  ): Promise<AnalysisTaskResponse> {
    const apiPayload = {
      from_address: template.from,
      subject: template.subject,
      body: template.body
    };
    return this.request<AnalysisTaskResponse>('post', '/analyze-template', apiPayload);
  }

  public static async getTaskStatus(
    taskId: string
  ): Promise<TaskResponse> {
    return this.request<TaskResponse>('get', `/tasks/${taskId}`);
  }

  public static async getModels(): Promise<ModelsResponse> {
    try {
      console.log('TemplateApi: Fetching models...');
      const response = await this.request<ModelsResponse>('get', '/models');
      console.log('TemplateApi: Models response:', response);
      return response;
    } catch (error) {
      console.error('TemplateApi: Error fetching models:', error);
      throw error;
    }
  }

  public static async rewriteTemplate(
    params: TemplateForm
  ): Promise<TaskResponse> {
    // Transform the form data to match the API's expected structure
    const apiPayload = {
      template: {
        from_address: params.from,
        subject: params.subject,
        body: params.body,
      },
      allowed_domains: params.allowedDomains,
      requested_sender_bias: params.senderBias,
      requested_content_biases: params.contentBiases,
      model: params.selectedModel
    };

    return this.request<TaskResponse>('post', '/rewrite-template', apiPayload);
  }

  public static async generateTemplate(
    params: TemplateGenerationParams
  ): Promise<GenerateResponse> {
    return this.request<GenerateResponse>('post', '/generate-template', params);
  }
}

export default TemplateApi;
